import { Schema } from 'normalizr';
import { transformUtil } from '@eb/transformation-utils';
// TODO: EB-144585 Take constants from TypeScript file
import {
    INSTRUMENT_TYPES,
    PAYMENT_METHODS,
    PAYMENT_METHODS_INFO,
    PAYMENT_OPTIONS_METHODS_TYPES,
} from '../../constants';

const paymentOptionsSchema = new Schema('payment_options');

const getInstrumentType = (instrument, paymentOption) => {
    const instrumentTypeForCreditCard =
        paymentOption.type === PAYMENT_OPTIONS_METHODS_TYPES.AUTHNET
            ? PAYMENT_METHODS.AUTHNET
            : PAYMENT_METHODS.CREDIT;

    return {
        ...instrument,
        type:
            instrument.type === INSTRUMENT_TYPES.CREDIT_CARD
                ? instrumentTypeForCreditCard
                : instrument.type,
    };
};

export const transformPaymentOptions = (data) => {
    const transformedPaymentOptions = transformUtil({
        response: data,
        schema: paymentOptionsSchema,
    });
    const paymentOptions =
        transformedPaymentOptions.entities.payment_options[
            transformedPaymentOptions.result
        ];

    // NOTE: The response from payment_options uses 'CREDIT_CARD' to identify credit cards.
    // The payment_methods endpoint expects 'CREDIT' when we set it. Since payment_options
    // is deprecated, we'll go with the payment_methods version.

    // Replace 'CREDIT_CARD' with 'CREDIT' (when using EPP) or 'AUTHNET' (when using Authnet) in instrument.type.
    paymentOptions.paymentOptions = paymentOptions.paymentOptions.map(
        (paymentOption) => ({
            ...paymentOption,
            instrumentTypes: paymentOption.instrumentTypes
                .map((instrument) =>
                    getInstrumentType(instrument, paymentOption),
                )
                // Filter out payment methods we do not support (those we don't have in PAYMENTS_METHODS_INFO)
                .filter((instrument) => PAYMENT_METHODS_INFO[instrument.type]),
        }),
    );

    return paymentOptions;
};
